import { createFileRoute, Outlet } from '@tanstack/react-router';

// Layout route for the /enrichment path segment.
// Visiting /trial/:platform/enrichment directly (without an id) is handled by
// the index child route, which redirects to /catalog-operations.
export const Route = createFileRoute('/_authenticated/_tenant/trial/$platform/enrichment')({
  component: () => <Outlet />,
});
